<!-- @format -->

<template>
	<widget-form-item
		v-show="getPropShow"
		v-model="selectField!.pcProps[itemKey]"
		:prop="itemKey"
		:type="getPropEditor.type"
		:pc-props="getPropEditor.pcProps"
		:item="selectField"
		v-bind="bindProps"
	/>
</template>

<script setup lang="ts">
	import WidgetFormItem from '../../../components/widget-form-item/index.vue';
	import { useDragStoreWithOut } from '../../../store';
	import { useBaseConfigStoreWithOut } from '../../../config/widget';
	import type { WidgetConfig } from '../../../types';

	interface Props {
		itemKey: string;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const name = inject<string>('name');
	const dragStore = useDragStoreWithOut(name);
	const baseConfigStore = useBaseConfigStoreWithOut(name);

	const selectField = computed({
		get() {
			return dragStore.selectField;
		},
		set(val) {
			dragStore.setState({ selectField: val });
		},
	});

	const getPropEditor = computed<WidgetConfig>(() => {
		return baseConfigStore.FIELDS_ATTRIBUTE[props.itemKey];
	});

	const bindProps = computed(() =>
		typeof getPropEditor.value.formItemProps === 'function'
			? (getPropEditor.value.formItemProps as Function)(selectField.value)
			: getPropEditor.value.formItemProps,
	);

	// 当前属性是否展示
	const getPropShow = computed(() => {
		// 隐藏不展示默认值的字段
		if (
			baseConfigStore.DONT_SHOW_DEFAULT_FIELDS.includes(selectField.value!.type) &&
			props.itemKey === 'defaultValue'
		) {
			return false;
		}

		// isPassword 为 false 时 showPassword 不展示
		if (!selectField.value?.pcProps.isPassword && props.itemKey === 'showPassword') {
			return false;
		}

		// multiple 为 false 时 multipleLimit不展示
		if (!selectField.value?.pcProps.multiple && props.itemKey === 'multipleLimit') {
			return false;
		}

		return true;
	});
</script>

<style scoped></style>
